import axios from 'axios';

const normalizeBaseUrl = (url) => (url || '').replace(/\/$/, '');

const baseURL = normalizeBaseUrl(
  process.env.VUE_APP_API_URL || 'http://localhost:5062'
);

const instance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default instance;
